import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityTransactionsReport  {
    _originalTypeClassName = "zERP.BO.TransactionEntityTransactionsReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityTransactionsReport.translate = translateService;
}
this.TransactionEntity = new Domain.TransactionEntity();
this.Transactions = [];
this.DateFrom = null;
this.DateTo = null;
this.TransactionEntityTransactionsReportKey = null;
this._key = this.TransactionEntityTransactionsReportKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
TransactionEntity:any;
Transactions:any;
PreviousReport:any;
TotalReport:any;
private _TransactionEntityTransactionsReportKey:any;
get TransactionEntityTransactionsReportKey(): any {
    return this._TransactionEntityTransactionsReportKey;
  }
set TransactionEntityTransactionsReportKey(value: any) {
    this._TransactionEntityTransactionsReportKey = value;
    this._key = value;
  }
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setTransactions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transactions == null) $this.Transactions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transactions.length > 0) {
                    Domain.TransactionEntityTransactionsReport.removeTransactions($this, $this.Transactions[0]);
                }

                Domain.TransactionEntityTransactionsReport.addManyTransactions($this, copyItems);
            }
static addManyTransactions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionEntityTransactionsReport.addTransactions($this, items[i]);
                }
            }
static addTransactions = ($this, item) => {
                if ($this.Transactions == null) $this.Transactions = [];
                if (item == null || $this.Transactions.indexOf(item) > -1) return;
                $this.Transactions.push(item);
}
static addRangeTransactions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionEntityTransactionsReport.addTransactions($this, item));
            }
static removeTransactions = ($this, item) => {
                if ($this == null || $this.Transactions == null || $this.Transactions.indexOf(item) === -1) return;
                var _index = $this.Transactions.indexOf(item);
                $this.Transactions.splice(_index, 1);
}
static clearTransactions = ($this) => { $this.Transactions = null; }
static setPreviousReport = ($this, value) => {
var oldValue = $this.PreviousReport;
$this.PreviousReport = value;
if (value != null) {
}
}
static setTotalReport = ($this, value) => {
var oldValue = $this.TotalReport;
$this.TotalReport = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityTransactionsReportKey == null || $this.TransactionEntityTransactionsReportKey == 0;
            }


}